<script>

    import ModalContainer from '../$components/modal.container.svelte'

    import ProviderComponent from './component.provider.svelte'
    import ProvidersComponent from './component.providers.svelte'
    import ProviderCreateComponent from './component.create.svelte'
    import ProviderUpdateComponent from './component.update.svelte'

    import TitleHero from '../$components/title.hero.svelte'
    import View from '../$layouts/view.layout.svelte'

</script>

<View>
    <div>
        <TitleHero title="Proveedores" subtitle="Consulta y gestión de proveedores" />
        <ProvidersComponent />
    </div>
</View>

<ModalContainer id="provider_modal" title="Proveedor" >
    <ProviderComponent showTitle={false} />
</ModalContainer>

<ModalContainer id="provider_create_modal" title="Crear proveedor" >
    <ProviderCreateComponent showTitle={false} />
</ModalContainer>

<ModalContainer id="provider_update_modal" title="Actualizar proveedor" >
    <ProviderUpdateComponent showTitle={false} />
</ModalContainer>